import { render } from "./CourseListItemSkeleton.vue?vue&type=template&id=2bff8e1e&ts=true"
import script from "./CourseListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./CourseListItemSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__